import React from 'react';
import withRouter from '@utils/wrappers/WithRouter';
import TableV3 from '@modules/tableV3/TableV3';
import { Icon, EntityCell, Typography } from '@ts/storybook';
import Link from '@components/Outputs/Link';
import NeedsManager from '@utils/NeedsManager';
import { getDisplayId, getUserFullName } from '@utils/helpers';
import _ from 'lodash';
import { Tooltip } from '@components';
import { withTranslation } from 'react-i18next';

class TaskItems extends React.Component {
  constructor(props) {
    super(props);
    this._route = this.props.transferPropsRoute;
    this.taskId = this.props.taskId || this._route.params.id;
    this.taskDescription = this.props.taskDescription;
    if (props.fPortal) this.state = { filter: this._route.query };
  }

  UNSAFE_componentWillMount() {
    if (!this.taskDescription) {
      new NeedsManager(this.props.data, [
        {
          url: `/api/task/${this.taskId}`,
          dataPath: `task`,
        },
      ]).fetchNeeds();
    }
  }

  componentDidUpdate() {
    this.taskDescription = this.props.data.getIn(['task', 'data', 'description']);
  }

  render() {
    let title = `${this.props.t('Items of task')}: ${this.taskDescription}`;
    return (
      <TableV3
        {...this.props}
        aclId="tsElement"
        componentId="itemsBase"
        title={title}
        itemsDataPath={'taskItems'}
        fnChange={this.props.fnChange}
        where={{ isAlive: true }}
        fnFilter={filter => this.setState({ filter })}
        columns={this._getColumns()}
        pkColumn="id"
        itemsFetchUrl={`/api/itemsByTask/${this.taskId}`}
        quickFindInit={this.props.quickFindInit}
        downloadOptions={{
          enable: true,
          fields: [{ label: 'name', value: 'name' }],
        }}
      />
    );
  }

  _getColumns = () => {
    return [
      {
        name: 'id',
        fHidden: true,
      },
      {
        fnLabel: () => this.props.t('Name / ID'),
        name: 'name',
        rawValue: o => {
          return o.get('name') ? o.get('name') : o.getIn(['elementType', 'name']);
        },
        filterValue(o, name) {
          return `${getDisplayId(o)} ${name}`;
        },
        render: (o, name) => (
          <EntityCell
            item={o}
            isEntitySelector={this.props.isEntitySelector}
            //id={o.get('logicalId')}
            //displayId={getDisplayId(o)}
            primaryLabel={o.get('name') ? o.get('name') : o.getIn(['elementType', 'name'])}
            entity="item"
          />
        ),
      },
      {
        fnLabel: () => this.props.t('Status'),
        name: 'status',
        rawValue: o => o.getIn(['currentStatus', 'indicators']),
        render: (o, indicators) => {
          indicators = indicators.toJS();
          return this.renderIndicators(indicators);
        },
      },
      {
        fnLabel: () => this.props.t('Current location'),
        name: 'currentLocation',
        rawValue: item => item.get('currentLocation'),
        filterValue(item, loc) {
          return loc.get('name');
        },
        render(item, loc, fnFilter) {
          return React.createElement(
            Link,
            {
              onClick() {
                return fnFilter({ currentLocationId: loc.get('id') });
              },
            },
            loc.get('name')
          );
        },
      },
      {
        fnLabel: () => this.props.t('Owner'),
        name: 'owner',
        rawValue: item => item.get('owner'),
        filterValue(item, owner) {
          return `${getDisplayId(owner)} ${getUserFullName(owner)}`;
        },
        render(item, owner) {
          return <Link href={`/user/${owner.get('logicalId')}/view`}>{getUserFullName(owner)}</Link>;
        },
      },
      {
        fnLabel: () => this.props.t('Holder'),
        name: 'holder',
        rawValue: item => item.get('holder'),
        filterValue(item, holder) {
          return `${getDisplayId(holder)} ${getUserFullName(holder)}`;
        },
        render(item, holder) {
          return <Link href={`/user/${holder.get('logicalId')}/view`}>{getUserFullName(holder)}</Link>;
        },
      },
    ];
  };

  renderIndicators(indicators) {
    let sortedInds = _.sortBy(indicators, function (o) {
      return o.indicator.name;
    });

    const { iconInds, textInds, noneInds } = this.splitIndicatorsByDisplay(sortedInds);

    return (
      <div style={{ minWidth: '200px' }}>
        <div>{this.renderIconIndicators(iconInds)}</div>
        <div>{this.renderTextIndicators(textInds)}</div>
      </div>
    );
  }

  splitIndicatorsByDisplay(indicators) {
    const iconInds = [],
      textInds = [],
      noneInds = [];
    const displayArrayMap = {
      icon: iconInds,
      text: textInds,
      none: noneInds,
    };
    indicators.forEach(ind => {
      const display = _.get(ind, 'indicator.props.display', 'icon');
      let array = displayArrayMap[display];
      array.push(ind);
    });
    return { iconInds, textInds, noneInds };
  }

  renderIconIndicators(indicators) {
    let icons = indicators.map(indicator => {
      const icon = {
        indName: indicator.indicator.name,
        indValue: indicator.props.value,
      };
      if (indicator.svgIcon) Object.assign(icon, { ...indicator.svgIcon });
      else icon.type = 'blank';
      return icon;
    });

    return icons.map(icon => {
      return (
        <Tooltip key={`${icon.indName}`} title={`${icon.indName}: ${icon.indValue}`}>
          <Icon icon={icon} />
        </Tooltip>
      );
    });
  }

  renderTextIndicators(indicators) {
    return indicators.map(ind => {
      const name = ind.indicator.name;
      const value = ind.props.value;

      return (
        <div key={`${name}`} className="mx-1">
          <Typography variant="subtitle2" display="inline" text={[name, ':']} />
          {` ${JSON.stringify(value) || ''}`}
        </div>
      );
    });
  }
}

TaskItems.defaultProps = {
  baseFilter: {},
};

const _style = {
  outer: {},
  id: {
    color: 'gray',
    fontSize: 10,
    whiteSpace: 'nowrap',
  },
  name: {},
};

export default withRouter(withTranslation()(TaskItems));
